import { filter } from 'rxjs/operators';
import { DungChungService } from './../../dung-chung/__services/dung-chung.service';
import moment from 'moment';
import { Injectable } from '@angular/core';
import { eventNames } from 'process';


@Injectable()
export class FunctionPublic {
	static fixedPoint: number = 5;
	static MIN_POINT: number = 2;
	static MAX_POINT: number = 5;
	static TEXT_MAX_POINT = "0,00000";
	static TEXT_MIN_POINT = "0,00";
  static defaultFixedPoint: number = 2; // Giá trị mặc định là 2
	constructor(
		private dungChungService: DungChungService,

	) { }

	//#region Format sử dụng cho số lượng
	public static preventAlpha(event) {
		let pCurrent = event.target.selectionStart;
		let pStart = ((pCurrent - 3) >= 0) ? (pCurrent - 3) : 0;
		let pEnd = ((pCurrent + 3) >= event.target.value.length) ? (pCurrent + 3) : event.target.value.length;
		if (event.key == ' ') { event.preventDefault(); }
		if (event.which == 32) { event.preventDefault(); }
		// Chặn nhập "," khi chưa có dữ liệu hoặc nhập "," ở vị trí đầu của số
		if (event.key == ',' && event.target.value[event.target.selectionStart] == ',') { event.target.selectionStart += 1; event.target.selectionEnd = event.target.selectionStart }

		if (event.key == ',' && (event.target.value.length == 0 || pCurrent == 0)) { event.preventDefault(); }

		// Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (event.key == ','
			&& ((event.target.value.substring(pStart, pCurrent).includes(','))
				|| (event.target.value.substring(pCurrent, pEnd).includes(','))
			)) { event.preventDefault(); }

		if (event.key == ','
			&& ((event.target.value.substring(0, pCurrent).includes(','))
				|| (event.target.value.substring(pCurrent, pEnd).includes(','))
			)) { event.preventDefault(); }

		// Chặn khi "." trước dấu "," và ngược lại
		if ((event.key == ',' && event.target.value.substring(0, pCurrent).includes('.'))
			|| (event.key == '.' && event.target.value.substring(pCurrent).includes(','))) { event.preventDefault(); }


		//if (event.key == ',' && event.target.value.length > 0){ return; }

		if ((event.key == ',' && (event.target.value.includes(',') || event.target.value.includes('.')))
			|| (event.key == '-')
			|| (event.key == '.' && (event.target.value.includes('.')))
		) { event.preventDefault(); return; }

		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

		if (isNaN(event.key) && !event.ctrlKey && event.key !== ',' && event.key !== '.') { event.preventDefault(); }

		if (event.key == ',' || event.key == '.') { return; }

		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;

		var found = event.key.match(regex);

		if (found != null) {
			event.preventDefault();
			return;
		}

	}

	public static preventAlphaV2(event) {
		let pCurrent = event.target.selectionStart;
		let pStart = ((pCurrent - 3) >= 0) ? (pCurrent - 3) : 0;
		let pEnd = ((pCurrent + 3) >= event.target.value.length) ? (pCurrent + 3) : event.target.value.length;
		if (event.key == ' ') { event.preventDefault(); }
		if (event.which == 32) { event.preventDefault(); }

		// Chặn nhập "," khi chưa có dữ liệu hoặc nhập "," ở vị trí đầu của số
		if (event.key == ',' && event.target.value[event.target.selectionStart] == ',') { event.target.selectionStart += 1; event.target.selectionEnd = event.target.selectionStart }

		if (event.key == ',' && (event.target.value.length == 0 || pCurrent == 0)) { event.preventDefault(); }

		// Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (event.key == '.'
			&& ((event.target.value.substring(pStart, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		if (event.key == '.'
			&& ((event.target.value.substring(0, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		// Chặn khi "." trước dấu "," và ngược lại
		if ((event.key == '.' && event.target.value.substring(0, pCurrent).includes(','))
			|| (event.key == ',' && event.target.value.substring(pCurrent).includes('.'))) { event.preventDefault(); }


		//if (event.key == ',' && event.target.value.length > 0){ return; }

		if ((event.key == '.' && (event.target.value.includes('.') || event.target.value.includes(',')))
			|| (event.key == '-')
			|| (event.key == ',' && (event.target.value.includes(',')))
		) { event.preventDefault(); return; }

		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

		if (isNaN(event.key) && !event.ctrlKey && event.key !== '.' && event.key !== ',') { event.preventDefault(); }

		if (event.key == '.' || event.key == ',') { return; }

		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;

		var found = event.key.match(regex);

		if (found != null && !event.ctrlKey) {
			event.preventDefault();
			return;
		}

	}

	public static cvKeyUp(event) {
		let evTarget = event.target;
		let key = event.key;
		let value = evTarget.value;
		let regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		const WHICH_SPACE = 32;
		const KEY_EMPTY = ' ';
		const KEY_COMMA = ',';
		const KEY_DOT = '.';
		const KEY_HYPHEN = '-';
		const KEY_INCORRECT = [8, 9, 37, 39, 46];

		// .. Lấy vị trí nháy, tính toán đầu, cuối
		let pCurrent = evTarget.selectionStart;
		let pStart = ((pCurrent - 3) >= 0) ? (pCurrent - 3) : 0;
		let pEnd = ((pCurrent + 3) >= value.length) ? (pCurrent + 3) : value.length;

		// .. Chặn giá trị '' và space (which = 32)
		if (key == KEY_EMPTY) { event.preventDefault(); }
		if (event.which == WHICH_SPACE) { event.preventDefault(); }

		// .. Chặn nhập ","
		// if (key == KEY_COMMA && value[pCurrent] == KEY_COMMA){ pCurrent += 1; evTarget.selectionEnd = pCurrent}
		// if (key == KEY_COMMA && (value.length == 0 || pCurrent == 0)){ event.preventDefault(); }
		if (key == KEY_COMMA) { event.preventDefault(); }

		// .. Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (key == KEY_DOT
			&& ((value.substring(pStart, pCurrent).includes(KEY_DOT)) || (value.substring(pCurrent, pEnd).includes(KEY_DOT)))) { event.preventDefault(); }

		if (key == KEY_DOT
			&& ((value.substring(0, pCurrent).includes(KEY_DOT)) || (value.substring(pCurrent, pEnd).includes(KEY_DOT))
			)) { event.preventDefault(); }

		// .. Trả về khi nhấn backspace, tab, arrow left, arrow right, delete
		if (KEY_INCORRECT.includes(event.keyCode)) { return; }

		// .. Chặn key không xác thực
		if (isNaN(key) && !event.ctrlKey && key !== KEY_DOT && key !== KEY_COMMA) { event.preventDefault(); }

		// .. Trả về khi nhấn .
		if (key == KEY_DOT) { return; }

		// .. Chặn chữ có dấu và ctrl key
		if (key.match(regex) != null && !event.ctrlKey) {
			event.preventDefault();
			return;
		}
	}

	public static preventAlphaPercent(event) {
		if (event.key == ' ') { event.preventDefault(); }
		if (event.which == 32) { event.preventDefault(); }
		// Chặn nhập "," khi chưa có dữ liệu hoặc nhập "," ở vị trí đầu của số
		if (event.key == '.' && (event.target.value.length == 0)) { event.preventDefault(); }

		// Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (event.key == '.'
			&& (event.target.value.substring(0).includes('.'))) { event.preventDefault(); }

		//if (event.key == ',' && event.target.value.length > 0){ return; }

		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

		//if(event.target.value.toString().indexOf('.') > 2 || (event.target.value.toString().indexOf('.') == -1 && event.target.value.toString().length > 2)) {event.preventDefault(); }

		if (isNaN(event.key) && !event.ctrlKey && event.key !== '.') { event.preventDefault(); }

		if (event.key == '.') { return; }

		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;

		var found = event.key.match(regex);

		if (found != null) {
			event.preventDefault();
			return;
		}

	}

	public static slListChanged(event) {
		// Nối kí tự đã nhấn vào
		if (event.key == ',') return false;
		let fullText = event.target.value.replace(/,/g, "");
		if (event.target.value == '.' && fullText.length == 1) return '0.00';
		// Thêm "," vào nhóm số nhiều hơn 4 chữ số
		let pThapPhan = (fullText.indexOf('.') > 0) ? fullText.indexOf('.') : fullText.length;

		let strNumber = fullText.substring(0, pThapPhan);

		for (let p = strNumber.length - 3; p > 0; p = p - 3) {
			strNumber = strNumber.substring(0, p) + "," + strNumber.substring(p);
		}
		if (pThapPhan == fullText.length) return strNumber;
		else return strNumber + fullText.substring(pThapPhan);
	}

	public static slListChangedV2(event) {
		// Nối kí tự đã nhấn vào
		if (event.key == '.') return false;

		let fullText = event.target.value.replace(/\./g, "");

		if ((event.target.value == ',' && fullText.length == 1) || event.target.value == "") return '0,00';

		// Thêm "," vào nhóm số nhiều hơn 4 chữ số
		let pThapPhan = (fullText.indexOf(',') > 0) ? fullText.indexOf(',') : fullText.length;

		let strNumber = fullText.substring(0, pThapPhan);

		for (let p = strNumber.length - 3; p > 0; p = p - 3) { strNumber = strNumber.substring(0, p) + "." + strNumber.substring(p); }

		var strNumberFinal: any;

		if (pThapPhan == fullText.length) strNumberFinal = strNumber;
		else strNumberFinal = strNumber + fullText.substring(pThapPhan, pThapPhan + 3);

		// Xử lý những trường hợp đặc biệt
		if (strNumberFinal.indexOf(",") == 0) strNumberFinal = "0" + strNumberFinal;
		if (strNumberFinal.indexOf(",") == -1) {
			strNumberFinal += ",00";
			strNumberFinal = this.F_NUMBER(this.F_NUMBER(strNumberFinal));
		}
		if (strNumberFinal.length > 4 && strNumberFinal[0] == "0" && strNumberFinal.indexOf(",") > 1) strNumberFinal = strNumberFinal.substring(1, strNumberFinal.length);

		return strNumberFinal;
	}
	//#endregion Format sử dụng cho số lượng

	//#region
	public static checkPositiveNumbers(event) {
		if (event.key === '-') { event.preventDefault(); }
		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
		if (event.key === '0' && event.target.value.length > 0) {
			var r = /[1-9]/g;
			var f = event.target.value.match(r);
			if (f == null) {
				event.preventDefault();
				return;
			}
		}
		var regex = /[0-9]/g;
		var found = event.key.match(regex);
		if (found == null) {
			event.preventDefault();
		}
	}

	public static kiemTraGiaTriMin(event, min: number) {
		if (event.key === '-') { event.preventDefault(); }
		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
		var regex = /[0-9]/g;
		var found = event.key.match(regex);
		if (found == null) {
			event.preventDefault();
		} else {
			let num = Number(event.target.value + event.key);

			if (num < min) {
				event.preventDefault();
			}
		}
	}

	//#region Export nhóm hàng hóa
	ExportFileExcel(filter, name) {
		this.dungChungService.exportFileExcel(filter).subscribe(blob => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = moment(new Date).format('YYYYMMDDHHmm') + "_" + name;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		});
	}
	//#endregion

	//#region Export hàng hóa
	ExportFileExcelHH(filter, name) {
		this.dungChungService.exportFileExcelHH(filter).subscribe(blob => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = moment(new Date).format('YYYYMMDDHHmm') + "_" + name;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		});
	}
	//#endregion

	// convert page-routing to notication
	public static ConvertPageroutingToNotifcation(link: string) {
		let linktemp = link.split("/");
		let routing: any = {};
		routing.page_routing = '/' + linktemp[1];
		routing.id = linktemp[2];
		return routing;
	}
	//

	//#region Convert tiền sang chữ
	public static convertCurrencyFromNumToStr(input: string) {
		let result = "";
		switch (input.length) {
			case 0:
				result = "";
				break;
			case 1:
				result = this.DonVi(input);
				break;
			case 2:
				result = this.Chuc(input);
				break;
			case 3:
				result = this.Tram(input);
				break;
			case 4:
				result = this.Nghin(input);
				break;
			case 5:
				if (input.substr(2, 3) == "000")
					result = this.Chuc(input.substr(0, 2)) + " nghìn ";
				else
					result = this.Chuc(input.substr(0, 2)) + " nghìn " + this.Tram(input.substr(2, 3));
				break;
			case 6:
				if (input.substr(3, 3) == "000")
					result = this.Tram(input.substr(0, 3)) + " nghìn ";
				else
					result = this.Tram(input.substr(0, 3)) + " nghìn " + this.Tram(input.substr(3, 3));
				break;
			case 7:
				result = this.DonVi(input.substr(0, 1)) + " triệu " + this.Tram(input.substr(1, 3)) + " nghìn " + this.Tram(input.substr(4, 3));
				break;
			case 8:
				if (input.substr(2, 6) == "000000")
					result = this.Chuc(input.substr(0, 2)) + " triệu ";
				else
					result = this.Chuc(input.substr(0, 2)) + " triệu " + this.Tram(input.substr(2, 3))
						+ " nghìn " + this.Tram(input.substr(5, 3))
				break
			case 9:
				if (input.substr(3, 6) == "000000")
					result = this.Tram(input.substr(0, 3)) + " triệu ";
				else
					result = this.Tram(input.substr(0, 3)) + " triệu " + this.Tram(input.substr(3, 3))
						+ " nghìn " + this.Tram(input.substr(6, 3))
				break
			case 10:
				if (input.substr(1, 9) == "000000000")
					result = this.DonVi(input.substr(0, 1)) + " tỷ ";
				else
					result = this.DonVi(input.substr(0, 1)) + " tỷ " + this.Tram(input.substr(1, 3))
						+ " triệu " + this.Tram(input.substr(4, 3)) + " nghìn " + this.Tram(input.substr(7, 3))
				break
			case 11:
				if (input.substr(2, 9) == "000000000")
					result = this.Chuc(input.substr(0, 2)) + " tỷ ";
				else
					result = this.Chuc(input.substr(0, 2)) + " tỷ " + this.Tram(input.substr(2, 3))
						+ " triệu " + this.Tram(input.substr(5, 3)) + " nghìn " + this.Tram(input.substr(6, 3))
				break
			case 12:
				if (input.substr(3, 9) == "000000000")
					result = this.Tram(input.substr(0, 3)) + " tỷ ";
				else
					result = this.Tram(input.substr(0, 3)) + " tỷ " + this.Tram(input.substr(3, 3))
						+ " triệu " + this.Tram(input.substr(6, 3)) + " nghìn " + this.Tram(input.substr(9, 3))
				break
		}
		let vt = result.lastIndexOf("không trăm ");
		if (vt > -1 && vt == result.length - 12) {
			result = result.substr(0, vt);
		}
		return result.replace("  ", " ").replace("mươi một", "mươi mốt").replace("mươi năm", "mươi lăm").trim();
	}
	private static Nghin(input: string) {

		let result = "";
		if (input === "1000") {
			result = " một nghìn ";
		}
		else {
			result = this.DonVi(input.substr(0, 1)) + " nghìn ";
			if (input.substr(1, 1) == "0") {
				if (input.substr(2, 1) == "0") {
					if (input.substr(3, 1) != "0") {
						result += this.DonVi(input.substr(1, 1)) + " trăm ";
						result += " lẻ " + this.DonVi(input.substring(input.length - 1));
					}
				}
				else {
					result += this.DonVi(input.substr(1, 1)) + " trăm ";
					result += this.Chuc(input.substr(2, 2));
				}
			}
			else {
				result += this.Tram(input.substr(1, 3));
			}
		}
		return result;
	}
	private static Tram(input: string) {

		let result = "";
		if (input === "100") {
			result = " một trăm ";
		}
		else {
			result += this.DonVi(input.substr(0, 1)) + " trăm ";
			if (input.substr(1, 1) == "0") {
				if (input.substr(2, 1) != "0")
					result += " lẻ " + this.DonVi(input.substr(2, 1))
			}
			else {
				result += this.Chuc(input.substr(1, 2));
			}
		}
		return result;
	}
	private static Chuc(input: string) {

		let result = "";
		if (input === "10") {
			result = " mười ";
		}
		else {
			if (input.substr(0, 1) == "1") {
				result += " mười " + this.DonVi(input.substr(1, 1))
			}
			else {
				result += this.DonVi(input.substr(0, 1)) + " mươi ";
				if ((input.substr(1, 1) != "0")) {
					result += this.DonVi(input.substr(1, 1));
				}
			}
		}
		return result;
	}
	private static DonVi(input: string) {

		let result = "";
		switch (input) {
			case "0":
				result += " không ";
				break;
			case "1":
				result += " một ";
				break;
			case "2":
				result += " hai ";
				break;
			case "3":
				result += " ba  ";
				break;
			case "4":
				result += " bốn ";
				break;
			case "5":
				result += " năm ";
				break;
			case "6":
				result += " sáu ";
				break;
			case "7":
				result += " bảy ";
				break;
			case "8":
				result += " tám ";
				break;
			case "9":
				result += " chín ";
				break;
		}
		return result;
	}
	//#endregion


	public static F_NUMBER(item: any) {
		const regex_c2n = /[-]?[0-9]{1,3}(?:\.?[0-9]{3})*,[0-9]{2}$/g;
		const regex_n2c = /^[-]?[0-9]{1,3}([0-9]{3})*(\.[0-9]{1,2})?$/g;
		const regex_c2c = /[-]?[0-9]{1,3}([0-9]{3})*,[0-9]{3,}/g;
		const regex_n2nM = /[-]?[0-9]{1,3}([0-9]{3})*\.[0-9]{3,}$/g;
		if (item == null || item == undefined || item.toString().trim() == "") return item;

		if (item.toString() && item.toString().match(regex_n2nM) != null) {
			item = Number(item).toFixed(2);
		}

		if (item.toString() && item.toString().match(regex_c2n) != null) {
			return this.formatComparenumber(item.toString()).toFixed(2);
		}

		if (item.toString() && item.toString().match(regex_n2c) != null) {
			//console.log('3: '+this.f_currency_VND(this.formatNumber(item.toString())));
			return this.f_currency_VND(this.formatNumber(item.toString()));
		}

		if (item.toString() && item.toString().match(regex_c2c) != null) {
			let n1: any = this.formatComparenumber(item.toString());
			n1 = Number(n1).toFixed(2);
			return this.f_currency_VND(this.formatNumber(n1.toString()));
		}

		return item;
	}

	//region hàm format từ dạng item = 123456.78 sang item = 123.456,78
	private static formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint);
	}

	private static f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	//#endregion

	//region hàm format từ dạng item = 123.456,78 sang item = 123456.78
	private static formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");
	}
	//#endregion
	//hàm chặn nhập kí tự đặc biệt cho số tài khoản kế toán
	public static preventAlphaV3(event) {
		let pCurrent = event.target.selectionStart;
		let pStart = ((pCurrent - 3) >= 0) ? (pCurrent - 3) : 0;
		let pEnd = ((pCurrent + 3) >= event.target.value.length) ? (pCurrent + 3) : event.target.value.length;
		if (event.key == ' ') { event.preventDefault(); }
		if (event.which == 32) { event.preventDefault(); }
		if (event.key == '.') { event.preventDefault(); }
		if (event.key == ',') { event.preventDefault(); }
		if (event.key == '-') { event.preventDefault(); }
		// Chặn nhập "," khi chưa có dữ liệu hoặc nhập "," ở vị trí đầu của số
		if (event.key == ',' && event.target.value[event.target.selectionStart] == ',') { event.target.selectionStart += 1; event.target.selectionEnd = event.target.selectionStart }

		if (event.key == ',' && (event.target.value.length == 0 || pCurrent == 0)) { event.preventDefault(); }

		// Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (event.key == '.'
			&& ((event.target.value.substring(pStart, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		if (event.key == '.'
			&& ((event.target.value.substring(0, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		// Chặn khi "." trước dấu "," và ngược lại
		if ((event.key == '.' && event.target.value.substring(0, pCurrent).includes(','))
			|| (event.key == ',' && event.target.value.substring(pCurrent).includes('.'))) { event.preventDefault(); }


		//if (event.key == ',' && event.target.value.length > 0){ return; }

		if ((event.key == '.' && (event.target.value.includes('.') || event.target.value.includes(',')))

			|| (event.key == ',' && (event.target.value.includes(',')))
		) { event.preventDefault(); return; }

		if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

		if (event.key == '-') { return; }

		if (isNaN(event.key) && !event.ctrlKey && event.key !== '.' && event.key !== ',') { event.preventDefault(); }



		if (event.key == '.' || event.key == ',') { return; }

		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;

		var found = event.key.match(regex);

		if (found != null) {
			event.preventDefault();
			return;
		}

	}
	public static preventAlphaV4(event) {
		
		if (event.key == '.' || event.key == ',' || event.key == 'Backspace') { return; }
		let pCurrent = event.target.selectionStart;
		let pStart = ((pCurrent - 3) >= 0) ? (pCurrent - 3) : 0;
		let pEnd = ((pCurrent + 3) >= event.target.value.length) ? (pCurrent + 3) : event.target.value.length;
		if (event.key == ' ') { event.preventDefault(); }
		if (event.which == 32) { event.preventDefault(); }
		if (event.key == '.') { event.preventDefault(); }
		if (event.key == ',') { event.preventDefault(); }
		// Chặn nhập "," khi chưa có dữ liệu hoặc nhập "," ở vị trí đầu của số
		if (event.key == ',' && event.target.value[event.target.selectionStart] == ',') { event.target.selectionStart += 1; event.target.selectionEnd = event.target.selectionStart }

		if (event.key == ',' && (event.target.value.length == 0 || pCurrent == 0)) { event.preventDefault(); }
		if (isNaN(event.key) && !event.ctrlKey && event.key !== '.' && event.key !== ',') { event.preventDefault(); }


		// Chặn khi phía trước hoặc phía sau đã có "," và cách nhau khác 3 chữ số
		if (event.key == '.'
			&& ((event.target.value.substring(pStart, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		if (event.key == '.'
			&& ((event.target.value.substring(0, pCurrent).includes('.'))
				|| (event.target.value.substring(pCurrent, pEnd).includes('.'))
			)) { event.preventDefault(); }

		// Chặn khi "." trước dấu "," và ngược lại
		if ((event.key == '.' && event.target.value.substring(0, pCurrent).includes(','))
			|| (event.key == ',' && event.target.value.substring(pCurrent).includes('.'))) { event.preventDefault(); }


		//if (event.key == ',' && event.target.value.length > 0){ return; }

		if ((event.key == '.' && (event.target.value.includes('.') || event.target.value.includes(',')))

			|| (event.key == ',' && (event.target.value.includes(',')))
		) { event.preventDefault(); return; }

		// if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9)
		// 	{ return; }

		if (event.key == '-') { return; }





		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;

		var found = event.key.match(regex);

		if (found != null) {
			event.preventDefault();
			return;
		}

	}

	public static cloneObject(object: any) {
		return JSON.parse(JSON.stringify(object));
	}

	// Format Number 4 Point

	private static fmNumberFourPoint(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + 4)) + 'e-' + 4).toFixed(4)
	}

	private static fmCurrency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.0000';
		let nbr = Number((value.substring(0, value.length - (4 + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (4 + 1), (4 + 1));
	}

	private static validNumberChange(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') count += 1;
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null || count >= 2) return false;
		return true;
	}

	public static displayFourPoint(tmpValue: string) {
		return this.fmCurrency(this.fmNumberFourPoint(tmpValue));
	}

	public static fmFourPoint(value: any, evt: any) {
		if (!this.validNumberChange(evt)) return evt.target.value;
		let tmpValue = value.replace(/,/g, "");
		return FunctionPublic.F_NUMBER_DYNAMIC(tmpValue, 4);
	}

	public static replaceNumber(value, commaCovDots: boolean = true) {
		return commaCovDots ? value.replace(".", "").replace(",", ".") : value.replace(",", "").replace(".", ",");
	}

	private genZero(num: number) {
		let s = "";
		for (let i = 0; i < num; i++) s += "0";
		return s;
	}

	// #region Hàm điều chỉnh format số đang dùng cho hệ thống
	// .. Hàm chặn keyup
	public static cvNumber(event) {
		const KEY_DOT = ".";
		const KEY_COMMA = ",";
		const REGEX_DOT = /\./g;
		const WHOLEPART_DIGITS = 3;
		var value = event.target.value;
		var orgText = value.replace(REGEX_DOT, "");
		var orgTextLen = orgText.length;
		const VALUE_DEFAULT = "0,00";
		const WHOLEPART_DEFAULT = "0";
		const THOUSANDTHS_DEFAULT = ",00";
		// .. Trả về ngay khi key là dấu chấm
		if (event.key == KEY_DOT) return false;
		if ((value == KEY_COMMA && orgTextLen == 1) || value == "") return VALUE_DEFAULT;
		// .. Lấy giá trị phần nguyên
		let lastIndexWholePart = (orgText.indexOf(KEY_DOT) > 0) ? orgText.indexOf(KEY_DOT) : orgTextLen;
		let wholePart = orgText.substring(0, lastIndexWholePart);
		let thousandths = orgText.substring(lastIndexWholePart + 1, lastIndexWholePart + 4);
		// .. Chèn "." vào phần ngàn của phần nguyên
		for (let index = wholePart.length - WHOLEPART_DIGITS; index > 0; index = index - WHOLEPART_DIGITS)
			wholePart = wholePart.substring(0, index) + KEY_DOT + wholePart.substring(index);
		// .. Chèn phần nguyên vào phần thập phân nếu có
		var finalNumber = (lastIndexWholePart == orgTextLen) ? wholePart : wholePart + KEY_COMMA + thousandths;
		// .. Xử lý những trường hợp đặc biệt
		var indexComma = finalNumber.indexOf(KEY_COMMA);
		switch (indexComma) {
			case -1:
				{
					finalNumber += THOUSANDTHS_DEFAULT;
					finalNumber = this.F_NUMBER(this.F_NUMBER(finalNumber));
					break;
				}
			case 0:
				{
					finalNumber = WHOLEPART_DEFAULT + finalNumber;
					break;
				}
		}
		if (finalNumber.length > 4 && finalNumber[0] == WHOLEPART_DEFAULT && finalNumber.indexOf(KEY_COMMA) > 1)
			finalNumber = finalNumber.substring(1, finalNumber.length);
		return finalNumber;
	}
	// .. Hàm format số dùng chung
	public static F_NUMBER_DYNAMIC(item: any, fixedPoint: number) {
		const MAX_POINT = fixedPoint > 0 ? fixedPoint : this.MAX_POINT;
		const MIN_POINT = this.MIN_POINT;
		const RIGHT_MAX_POINT = MAX_POINT + 1;
		const VALUE_INCORRECT = [null, undefined];
		let regex_c2n = new RegExp("[-]?[0-9]{1,3}(?:\.?[0-9]{3})*,[0-9]{" + MIN_POINT + "," + MAX_POINT + "}$");
		let regex_n2c = new RegExp("^[-]?[0-9]{1,3}([0-9]{3})*(\.[0-9]{1," + MAX_POINT + "})?$");
		let regex_c2c = new RegExp("[-]?[0-9]{1,3}([0-9]{3})*,[0-9]{" + RIGHT_MAX_POINT + ",}");
		let regex_n2nM = new RegExp("[-]?[0-9]{1,3}([0-9]{3})*\.[0-9]{" + RIGHT_MAX_POINT + ",}$");
		if (VALUE_INCORRECT.includes(item) || item.toString().trim() == "") return item;
		var newItem = item.toString().trim().toString();
		if (newItem && newItem.match(regex_n2nM) != null)
			newItem = Number(newItem).toFixed(MAX_POINT);
		if (newItem && regex_c2n.test(newItem))
			return this.formatComparenumber(newItem).toFixed(MAX_POINT);
		if (newItem && regex_n2c.test(newItem))
			return this.cvDynamic(newItem);
		if (newItem && regex_c2c.test(newItem))
			return this.cvDynamic(Number(this.formatComparenumber(newItem).toFixed(MAX_POINT)));
		return newItem;
	}
	// .. Hàm ép kiểu số
	public static cvDynamic(value: number) {
		return this.fCurrDynamic(this.fmNumberDynamic(value.toString()));
	}
	// .. Hàm điều chỉnh cho yêu cầu hiện số thập phân min 2 số max 5 số
	private static fmNumberDynamic(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.MAX_POINT)) + 'e-' + this.MAX_POINT).toFixed(this.MAX_POINT);
	}
	private static fCurrDynamic(value: string): any {
		if (value == null || value == undefined) return '0,' + genZero(this.MIN_POINT);
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: this.MIN_POINT, maximumFractionDigits: this.MAX_POINT }).format(Number(value));
	}
	// #endregion

}
function genZero(dynamicPoint: number) {
	throw new Error('Function not implemented.');
}

